import React from "react";
import { AppContext } from "../../contexts/AppContext";
import Card from "../../components/page/Card";
import DadosCobranca from "./Configuracoes/DadosCobranca";
import PersonalizarCobranca from "./Configuracoes/PersonalizarCobranca";
import CommonButton from "../../components/buttons/CommonButton";
import ChaveIntegracao from "./Configuracoes/ChaveIntegracao";
import CobrancaApiClient from "../../api/cobranca";
import { amazonLink } from "../../constants/common";
import useApi from "../../hooks/useApi";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";

function Configuracoes() {
  const { session } = React.useContext(AppContext);
  const [values, setValues] = React.useState({
    emitir_nfse: true,
    enviar_email: true,
    multas_juros: true,
    cor: "#EE640A",
  });
  const [originalValues, setOriginalValues] = React.useState({});

  const { request: getConfig, data: configResponse } = useApi(
    CobrancaApiClient.getConfig,
    false
  );
  const postLogoApi = useApi(CobrancaApiClient.postLogo);
  const postConfigApi = useApi(CobrancaApiClient.postConfig);

  //Busca configurações ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getConfig(session.empresa.replace(/E/gi, ""));
  }, [getConfig, session.empresa]);

  //Define o retorno da api nos valores das configurações
  React.useEffect(() => {
    if (!configResponse) return;
    setValues((prevValues) => ({
      ...prevValues,
      descricao_servico_prestado:
        configResponse.config.descricao_servico_prestado,
      tipo_vencimento: configResponse.config.tipo_vencimento,
      dia: configResponse.config.dia,
      emitir_nfse: configResponse.config.emitir_nfse === 1,
      enviar_email: configResponse.config.enviar_email === 1,
      multas_juros: configResponse.config.multas_juros === 1,
      tipo_multa: String(configResponse.config.tipo_multa),
      multa: configResponse.config.multa,
      tipo_juros: String(configResponse.config.tipo_juros),
      juros: configResponse.config.juros,
      logomarca: configResponse.config.logomarca
        ? amazonLink + configResponse.config.logomarca
        : "",
      nome_empresa: configResponse.config.nome_empresa,
      cor: configResponse.config.cor,
      client_id_sent: configResponse.integracoes?.inter?.client_id,
      client_secret_sent: configResponse.integracoes?.inter?.client_secret,
      arquivo_crt_sent: configResponse.integracoes?.inter?.arquivo_crt,
      arquivo_key_sent: configResponse.integracoes?.inter?.arquivo_key,
      crt_validade: configResponse.integracoes?.inter?.validade_crt || "",
    }));

    setOriginalValues((prevOriginalValues) => ({
      ...prevOriginalValues,
      descricao_servico_prestado:
        configResponse.config.descricao_servico_prestado,
      tipo_vencimento: configResponse.config.tipo_vencimento,
      dia: configResponse.config.dia,
      emitir_nfse: configResponse.config.emitir_nfse === 1,
      enviar_email: configResponse.config.enviar_email === 1,
      multas_juros: configResponse.config.multas_juros === 1,
      tipo_multa: String(configResponse.config.tipo_multa),
      multa: configResponse.config.multa,
      tipo_juros: String(configResponse.config.tipo_juros),
      juros: configResponse.config.juros,
      logomarca: configResponse.config.logomarca
        ? amazonLink + configResponse.config.logomarca
        : "",
      nome_empresa: configResponse.config.nome_empresa,
      cor: configResponse.config.cor,
    }));
  }, [configResponse]);

  const salvaImagem = async () => {
    if (!values.imagePreview) {
      return ErrorSwal({
        text: "Nenhuma imagem selecionada",
      });
    }

    const formData = new FormData();
    formData.append("arquivo", values.logomarca);

    const response = await postLogoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Logomarca salva com sucesso!",
      icon: "success",
    });
  };

  const salvaConfiguracao = async () => {
    const formData = new FormData();

    const campos = [
      "descricao_servico_prestado",
      "tipo_vencimento",
      "dia",
      "emitir_nfse",
      "enviar_email",
      "multas_juros",
      "tipo_multa",
      "multa",
      "tipo_juros",
      "juros",
      "nome_empresa",
      "cor",
      "client_id",
      "client_secret",
    ];

    const dataObj = {};

    if (values?.arquivo_crt && values?.arquivo_crt !== "") {
      formData.append("arquivo_crt", values["arquivo_crt"]);
    }

    if (values?.arquivo_key && values?.arquivo_key !== "") {
      formData.append("arquivo_key", values["arquivo_key"]);
    }

    campos.forEach((campo) => {
      if (["tipo_multa", "multa", "tipo_juros", "juros"].includes(campo)) {
        if (!values.multas_juros && "" !== originalValues[campo]) {
          dataObj[campo] = null;
        } else if (values[campo] !== originalValues[campo]) {
          dataObj[campo] = values[campo];
        }
      } else if (values[campo] !== originalValues[campo]) {
        dataObj[campo] = values[campo];
      }
    });

    formData.append("JSON", JSON.stringify(dataObj));

    if (formData.entries().next().done)
      return CommonSwal({
        title: "Configurações salvas com sucesso!",
        icon: "success",
      });

    const response = await postConfigApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Configurações salvas com sucesso!",
      icon: "success",
    });
  };

  return (
    <>
      <Card>
        <DadosCobranca valuesHook={{ values, setValues }} />
        <PersonalizarCobranca
          valuesHook={{ values, setValues }}
          salvaImagem={salvaImagem}
        />
        <div className="row text-end">
          <div className="col">
            <CommonButton onClick={salvaConfiguracao} color="success">
              Salvar configurações
            </CommonButton>
          </div>
        </div>
      </Card>
      {session.codigo === "99" ? (
        <Card>
          <ChaveIntegracao valuesHook={{ values, setValues }} />
        </Card>
      ) : null}
    </>
  );
}

export default Configuracoes;
